import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BartSatellite from './bart-satellite';
import { getUserRole } from '../../../../../../../redux/selectors';
import { scheduleActions } from '../../../redux-saga/actions';

export const BartSync: React.FC = () => {
  const dispatch = useDispatch();
  const userRoles = useSelector(getUserRole);

  const onSyncFinished = () => {
    setTimeout(() => {
      dispatch(scheduleActions.reFetchAllEntries());
    }, 1000);
  };

  return userRoles?.includes('admin') && <BartSatellite onSyncFinished={onSyncFinished} />;
};
